export default __webpack_public_path__ + "static/badge-download-on-the-mac-app-store-1d39e8dace6b366637c5a86a05efe854.svg";